import React, { useEffect } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import "./About.css"; // Premium styles including leaves animation
import leaf from "../assets/leaf.jpg"
import aboutpic from "../assets/about.png"

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="about-page">
      {/* Floating Herbal Leaves */}
      <div className="floating-leaves">
        {[...Array(8)].map((_, i) => (
          <img
            key={i}
            src={leaf}
            alt="leaf"
            className={`leaf leaf-${i + 1}`}
          />
        ))}
      </div>

      {/* Premium Hero Section */}
      <div className="about-hero d-flex align-items-center justify-content-center text-center">
        <motion.h1
          className="display-4 fw-bold text-white"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
           <span className="highlight">RoupanNaturals</span>
        </motion.h1>
      </div>

      {/* About Content */}
      <div className="container py-5">
        <div className="row align-items-center gy-5">
          {/* Image */}
          <div className="col-md-6" data-aos="fade-right">
            <motion.div
              whileHover={{ scale: 1.03 }}
              transition={{ type: "spring", stiffness: 200 }}
              className="image-wrapper"
            >
              <img
                src={aboutpic}
                alt="About Roupan Naturals"
                className="img-fluid rounded-4 shadow-lg about-image"
                style={{ maxWidth: "90%", height: "auto" }}
              />
            </motion.div>
          </div>

          {/* Text */}
          <div className="col-md-6 text-section" data-aos="fade-left">
            <motion.h2
              className="fw-bold mb-4"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
            >
              Our Story
            </motion.h2>
            <motion.p
              className="lead text-muted"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.8 }}
            >
              Welcome to <strong>Roupan Naturals</strong> — your trusted source for
              natural and organic wellness. Launching a new era of beauty infused with the essence of India.
              Our products are made from high-quality natural ingredients
              designed to enhance your beauty while nurturing your skin.
              <br />
              Join us in celebrating beauty that’s good for you & the Earth.
            </motion.p>
            <motion.p
              className="text-muted"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.5, duration: 0.8 }}
            >
             
            </motion.p>

            <motion.a
              href="/products"
              className="btn btn-premium mt-3 bg-dark text-light bg-hover-light"
              whileHover={{ scale: 1.05, boxShadow: "0 8px 20px rgba(0,0,0,0.3)" }}
              whileTap={{ scale: 0.95 }}
            >
              Explore Our Products 
            </motion.a>
          </div>
        </div>
      </div>

      {/* Mission Section */}
      <div className="container-fluid mission-section text-center text-white py-5" data-aos="fade-up">
        <div className="container">
          <h2 className="fw-bold mb-4">Our Mission</h2>
          <p className="mx-auto" style={{ maxWidth: "700px" }}>
            To empower people with the purity of nature, delivering beauty and
            wellness products that are sustainable, effective, and ethical.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
